<template
  ><b-container fluid v-if="scoreReport"
    ><b-row class="tsny_border-top"
      ><b-col class="col-xl-auto col-lg-4 tsny_box-padding tsny_box-fill"
        ><b-row
          ><b-col
            ><h2 class="tsny_header">
              {{ scoreReport.examName }}
            </h2></b-col
          >
        </b-row>
        <b-row>
          <b-col>
            <div class="tsny_text">
              {{ examDate }}
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <div class="tsny_text">
              {{ scoreReport.courseId }}
            </div>
          </b-col>
        </b-row>
      </b-col>
      <b-col class="col-xl-auto col-lg-8 tsny_box-padding tsny_box-fill">
        <b-row>
          <b-col class="tsny_box-padding tsny_border-right">
            <b-row>
              <b-col>
                <div class="tsny_text text-black font-weight-bold text-center">
                  Composite
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <div
                  class="tsny_text text-center score"
                  :style="{ color: scoreReport.color }"
                >
                  {{ scoreReport.compositeScore }}
                </div>
              </b-col>
            </b-row>
          </b-col>
          <b-col
            v-for="section in sections"
            :key="section"
            class="tsny_box-padding"
          >
            <b-row>
              <b-col>
                <div class="tsny_text text-center">
                  {{ section }}
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <div class="tsny_text text-center score">
                  {{ scoreReport[section].scaledScore }}
                </div>
              </b-col>
            </b-row></b-col
          >
        </b-row>
      </b-col>
      <b-col
        class="col-xl-auto col-lg-6 tsny_box-padding tsny_text-mid text-right"
      >
        <b-row class="mb-2">
          <b-col>
            <div class="tsny_link" @click="viewReport">
              <span class="link_margin">Full Report</span
              ><i class="far fa-calendar-alt fa-fw tsny_icon-margin" />
            </div>
          </b-col> </b-row
        ><b-row class="mb-2">
          <b-col>
            <div class="tsny_link">
              <span class="link_margin">Download Report</span
              ><i class="fa fa-download fa-fw tsny_icon-margin" />
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <div class="tsny_link" @click="$emit('delete-report')">
              <span class="link_margin">Delete Report</span
              ><i class="fa fa-trash fa-fw tsny_icon-margin" />
            </div>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import moment from "moment";
import Constants from "../../services/Constants";

export default {
  name: "ScoreReportOverview",
  props: {
    scoreReport: {
      type: Object,
      default: null
    }
  },
  computed: {
    examDate() {
      return this.scoreReport.date
        ? moment(this.scoreReport.date).format("MMMM DD, YYYY")
        : "";
    },
    sections() {
      return Constants.EXAM_SECTIONS[this.scoreReport.courseId].SECTIONS;
    }
  },
  methods: {
    viewReport() {
      this.$router.push({
        name: "ScoreReport",
        params: {
          scoreReport: this.scoreReport
        }
      });
    }
  }
};
</script>

<style scoped>
.score {
  font-size: 37px;
}

.link_margin {
  margin-right: 30px;
}

.tsny_icon-margin {
  margin-left: -16px;
  width: 17px;
}
</style>
